/** @jsx jsx */
import { jsx, Container, Flex, Box } from 'theme-ui'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { Image } from '../../components/Images'
import { MasterDisclaimer } from '../../components/MasterDisclaimer'
import { Icon } from '../../components/Icons'
import { WebAnalytics } from '../../components/SEO'
import { StaticImage } from 'gatsby-plugin-image'

const Footer = ({ disclaimers }: { disclaimers?: JSX.Element[] }) => {
  const data = useStaticQuery(
    graphql`
      query {
        logo: file(relativePath: { eq: "logos/logo.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
        safeSecure: file(
          relativePath: { eq: "logos/safe_secure_confidential.png" }
        ) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
      }
    `
  )

  const linkList = [
    {
      link: '/privacy-policy/',
      label: 'Privacy Policy',
    },
    {
      link: '/terms-of-use/',
      label: 'Terms of Use',
    },
    {
      link: '/mail/terms-and-conditions/',
      label: 'Terms & Conditions',
    },
    {
      link: '/communication-preferences/',
      label: 'Communication Preferences',
    },
    {
      link: '/faqs/',
      label: 'FAQs',
    },
  ]
  return (
    <footer role={'footer'} sx={{ backgroundColor: 'white' }}>
      <Container>
        <Box
          sx={{
            mb: '25px',
            backgroundColor: 'white',
          }}
        >
          <Flex
            sx={{
              display: ['block', null, null, 'flex'],
              justifyContent: 'space-between',
              position: 'relative',
            }}
          >
            <Box
              sx={{
                mb: [0, 3, 3, 0],
              }}
            >
              <Link
                to="/"
                style={{
                  textDecoration: `none`,
                }}
              >
                <StaticImage
                  src="../../images/logos/logo.png"
                  alt="Avio Logo"
                  placeholder="none"
                  loading="eager"
                  sx={{
                    width: '235px',
                    m: '0 auto',
                    '& img': {
                      objectFit: 'contain !important',
                    },
                  }}
                />
              </Link>
            </Box>
            <Box sx={{ display: ['block', 'block', 'flex'] }}>
              <ul
                sx={{
                  margin: ['30px auto', '30px auto', '0 auto'],
                  listStyle: 'none',
                  padding: '0',
                }}
              >
                {linkList.map((link, i) => (
                  <li
                    key={`${i}`}
                    sx={{
                      p: 0,
                      py: '10px',
                      position: 'relative',
                      textAlign: 'center',
                      display: ['block', 'block', 'inline-flex'],
                      alignItems: 'center',
                    }}
                  >
                    <Link
                      sx={{
                        fontFamily: 'nimbus-sans, sans-serif',
                        color: '#707070',
                        textDecoration: 'none',
                        fontSize: '16px',
                        mr: [0, '10px', null, null, '15px'],
                      }}
                      to={`${link.link}`}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </Box>
          </Flex>
        </Box>
        <MasterDisclaimer disclaimers={disclaimers} />
        <Box
          sx={{
            margin: '0 auto',
            display: 'block',
            position: 'relative',
            textAlign: 'center',
          }}
        >
          <small
            sx={{
              color: '#3E4543',
              fontSize: '12px',
              fontFamily: 'nimbus-sans, sans-serif',
            }}
          >
            &copy; {new Date().getFullYear()} Avío Credit. All Rights Reserved.
          </small>
        </Box>
        <Flex sx={{ columnGap: '30px', justifyContent: 'center', mt: '30px' }}>
          <Box>
            <Image
              sx={{
                width: '97px',
                m: '0 auto',
                mb: 2,
                display: 'block',
              }}
              fluid={data.safeSecure.childImageSharp.fluid}
            />
          </Box>
          <Box>
            <a
              target="_blank"
              rel="external nofollow noreferrer noopener"
              href="https://www.trustedsite.com/verify?host=www.aviocredit.com&test=Y"
              sx={{ p: 2 }}
            >
              <Icon
                viewBox="0 0 120 50"
                name="trusted-site"
                sx={{ width: '102px' }}
              />
            </a>
          </Box>
        </Flex>
      </Container>
      <WebAnalytics />
    </footer>
  )
}
export default Footer